export default __webpack_public_path__ + "static/media/abhiyuthan_logo.f7f13cb3.png";